<template>
  <Popper placement="right">
    <i
      role="button"
      class="fa-solid fa-truck px-2"></i>
    <template #content>
      <div v-if="task.semitrailer" class="text-primary fw-bolder my-2">
        <span v-if="task.semitrailer.id === 304" class="text-danger">
          Brak naczepy
        </span>
        <span v-else>
          Obecna naczepa: {{ task.semitrailer.plateNumber }}
        </span>
      </div>
      <div v-else-if="!task.semitrailer || task.semitrailerId === 304" class="text-danger fw-bolder">
        Brak naczepy
      </div>
      <form @submit.prevent="changeTrailer" class="px-5">
        <label>
          Zawęź wyniki wpisując tekst:
          <input type="text" v-model="searchText" class="form-control" @input="fetchTrailers" placeholder="Nr rejestracyjny">
        </label>
        <label class="d-block mt-3">
          Zmień naczepę:
          <select
            class="d-inline form-select"
            v-model="selectedTrailerId"
            @focus="fetchTrailers"
            required>
            <option :value="null">
              -- wybierz nową naczepę --
            </option>
            <option
              v-for="(trailer, trailerIndex) in trailers"
              :key="trailerIndex"
              :value="trailer.id">
              {{ trailer.plateNumber }}
            </option>
          </select>
        </label>
        <button
          class="btn btn-sm btn-success mt-2 d-block mx-auto"
          type="submit"
        >
          Zatwierdź naczepę
        </button>
      </form>
      <button v-if="task.semitrailerId !== 304" @click="setEmptyTrailer" class="btn btn-sm btn-warning mt-2 d-block mx-auto">
        Ustaw opcję 'brak naczepy'
      </button>
    </template>
  </Popper>
</template>

<script>
import Popper from 'vue3-popper'
import axios from 'axios'
import Swal from 'sweetalert2'
import emitter from '@/modules/events/emitter'
import { $axios } from '@/modules/http/axios'

export default {
  name: 'AttachedTrailer',
  components: { Popper },
  props: ['task'],
  data () {
    return {
      trailers: [],
      selectedTrailerId: null,
      searchText: ''
    }
  },
  methods: {
    async fetchTrailers () {
      this.isLoading = true
      const searchText = this.searchText.trim()
      try {
        this.trailers = (await $axios.get('Trailer')).data
        if (this.searchText !== '') {
          this.trailers = this.trailers.filter(trailer => trailer.plateNumber.toLowerCase().includes(searchText.toLowerCase()))
        }

        this.trailers = this.trailers.filter((trailer) => {
          return trailer.hidden === false
        })
      } catch (e) {
        console.log(e)
      } finally {
        this.isLoading = false
      }
    },
    async changeTrailer () {
      const postData = { semitrailerId: this.selectedTrailerId }

      try {
        await $axios.post(`Task/${this.task.id}/Semitrailer`, postData)
        emitter.emit('taskChanged', { taskId: this.task.id })
        await Swal.fire(`Zmieniono naczepę dla zlecenia ${this.task.id}`, '', 'success')
      } catch (e) {
        if (e.response?.status === 400) {
          const dialogResult = await Swal.fire({
            title: 'Naczepa jest już dodana do innego zlecenia. Czy chcesz dodać naczepę mimo to?',
            icon: 'question',
            showCancelButton: true,
            showConfirmButton: true,
            cancelButtonText: 'Nie',
            confirmButtonText: 'Tak'
          })

          if (dialogResult.isConfirmed) {
            const postData = {
              semitrailerId: this.selectedTrailerId,
              skipValidation: true
            }

            await $axios.post(`Task/${this.task.id}/Semitrailer`, postData)
            emitter.emit('taskChanged', { taskId: this.task.id })
            await Swal.fire('Dodano naczepę do kolejnego zlecenia', '', 'success')
          }
        }
      }
    },
    async setEmptyTrailer () {
      const postData = { semitrailerId: 304, skipValidation: true }

      await $axios.post(`Task/${this.task.id}/Semitrailer`, postData)
      emitter.emit('taskChanged', { taskId: this.task.id })
      await Swal.fire(`Ustawiono opcję "Brak naczepy" dla zlecenia ${this.task.numer_Przejazdu}`, '', 'success')
    },
  }
}
</script>
